<template>
  <svg :width="width" :height="width" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.91 37.67"><path d="M27.24 16.7l8.29-8.29c.47-.47.47-1.23 0-1.7l-2.5-2.5c-.47-.47-1.23-.47-1.7 0l-8.29 8.29-8.29-8.29c-.47-.47-1.23-.47-1.7 0l-2.5 2.5c-.47.47-.47 1.23 0 1.7l8.29 8.29-8.29 8.3c-.47.47-.47 1.23 0 1.7l2.5 2.5c.47.47 1.23.47 1.7 0l8.29-8.29 8.29 8.29c.47.47 1.23.47 1.7 0l2.5-2.5c.47-.47.47-1.23 0-1.7l-8.29-8.3z" :stroke="currentColor"/></svg>
  <!-- <svg :width="width" :height="width" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 24 24" class="transform hover:scale-110"><path d="M12 11.293l10.293-10.293.707.707-10.293 10.293 10.293 10.293-.707.707-10.293-10.293-10.293 10.293-.707-.707 10.293-10.293-10.293-10.293.707-.707 10.293 10.293z" fill="currentColor" :stroke="currentColor" stroke-width="6%"/></svg> -->
</template>

<script>
  export default {
    name: 'Close',
    props: {
      stroke: {
        type: Boolean,
        default: false
      },
      width: {
        type: String,
        default: '40'
      }
    },
    computed: {
      currentColor () {
        return this.stroke ? 'currentColor' : 'none'
      }
    }
  }
</script>
